import { type Access, accessesGetByIdQueryKey } from "@hooks/trpc/useAccesses";
import type { DataSession } from "../../../../data/core/session";

export function markMusicAccessUnlocked(data: DataSession, accessId: string) {
  data.cache.setQueryDataDurable<Access>(
    data.queryClient,
    accessesGetByIdQueryKey(accessId),
    (cached) =>
      cached?.type === "music" ? { ...cached, unlocked: true } : cached,
  );
}
